<template>
    <div class="container">
        <div class="header">
            <h1 class="el-row">外语学能测试（视听版v1.0）<br />
                TALL (Aural Suite v1.0)</h1>
        </div>
        <div class="content" style="margin-top: 50px">
            <div class="left"></div>
            <div class="center">
                <el-form :model="form" ref="dynamicValidateForm" class="demo-dynamic">
                    <div>
                        <div class="row">
                            <div>
                                <el-form-item label-position="right" prop="email" label="email" :rules="[
                                    { required: true, message: 'Please input email', trigger: 'blur' },
                                    { type: 'email', message: 'Please input correct email', trigger: ['blur', 'change'] }
                                ]">
                                    <el-input v-model="form.email" placeholder="Please input email"></el-input>
                                </el-form-item>
                            </div>
                        </div>
                        <div class="row">
                            <div>
                                <el-form-item label-position="right" prop="email" label="Confirm email" :rules="[
                                    { required: true, message: 'Please input email', trigger: 'blur' },
                                    { type: 'email', message: 'Please input correct email', trigger: ['blur', 'change'] }
                                ]">
                                    <el-input v-model="testemail"
                                        placeholder="The email entered twice must be consistent"></el-input>
                                </el-form-item>
                            </div>
                        </div>

                        <div class="yesbutton">

                            <el-button :disabled="show" type="primary"
                                @click="submitForm('dynamicValidateForm')">登录</el-button>
                        </div>
                    </div>
                </el-form>
            </div>
            <div class="right"></div>
        </div>
        <div class="footer"></div>
    </div>

</template>
<script>
import GLOBAL from "../plugins/global_variable";

export default {
    name: "Emaillogin",
    data() {
        return {
            testemail: '',
            show: true,
            form: {
                email: '',
                invited_code: '',
            }
        };
    },
    created() {
        document.body.style.backgroundColor = "#DCDCDC";
    },
    watch: {
        'testemail': function () {
            if (this.testemail == this.form.email) {
                this.show = false
                this.$forceUpdate();
            }
            else {
                this.show = true
                this.$forceUpdate();
            }
        }
    },
    methods: {
        //比较两个时间是否大于一个月，例如20170215--到20170315 是一个月，到20170316是大于一个月
        getD(sDate, endDate) {
            var sDate = new Date(sDate);
            var eDate = new Date(endDate);
            if (eDate.getFullYear() - sDate.getFullYear() > 1) {//先比较年
                return true;
            } else if (eDate.getMonth() - sDate.getMonth() > 1) {//再比较月
                return true;
            } else if (eDate.getMonth() - sDate.getMonth() == 1) {
                if (eDate.getDate() - sDate.getDate() >= 1) {
                    return true;
                }
            } else if (eDate.getFullYear() - sDate.getFullYear() == 1) {
                if (eDate.getMonth() + 12 - sDate.getMonth() > 1) {
                    return true;
                } else if (eDate.getDate() - sDate.getDate() >= 1) {
                    return true;
                }
            }
            return false;
        },

        getD24h(startDate, endDate) {
            let sDate = new Date(startDate);
            let eDate = new Date(endDate);
            let diff = eDate.getTime() - sDate.getTime();
            diff = Math.floor(diff / (1000 * 60 * 60));
            return diff >= 24;
        },
        getD1m(startDate, endDate) {
            let sDate = new Date(startDate);
            let eDate = new Date(endDate);
            console.log(sDate)
            console.log(eDate)
            let diff = eDate.getTime() - sDate.getTime();
            diff = Math.floor(diff / (1000 * 60)); // 将计算单位改为分钟
            console.log(diff)
            return diff >= 1; // 判断是否相隔至少1分钟
        },

        submitForm(formName) {
            var _this = this;
            this.$refs[formName].validate((valid) => {
                // 如果邮箱格式正确
                if (valid) {
                    _this.find_user_email();
                }
                // 如果邮箱格式不正确
                else {
                    return false;
                }
            });

        },

        find_user_email() {
            //查询邮箱是否已被使用
            var _this = this;
            axios.get('user/findAllByEmail' + this.form.email).then(function (resp) {
                //查询查询到这个邮箱
                if (resp.data) {
                    //如果完成了文字版的练习且未完成视听版测试
                    if (resp.data.word_done === 'true') {
                        var date = new Date()
                        var now_date = date.getFullYear() + "/" + (date.getMonth() + 1) + "/" + date.getDate() + " " + date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds(); //完成时间
                        GLOBAL.session = 'second';
                        //这里需要存的全局变量邮箱应该是由后端发来的邮箱
                        GLOBAL.email = resp.data.email;
                        // _this.$router.push('/Index');
                        //如果完成文字版的时间间隔了一个月
                        if (_this.getD1m(resp.data.word_donetime, now_date)) {
                            //如果视听版未完成
                            if (resp.data.aural_done === 'false') {
                                _this.$message({
                                    message: 'Login successfully！',
                                    type: 'success',

                                });
                                GLOBAL.session = 'second';
                                //这里需要存的全局变量邮箱应该是由后端发来的邮箱
                                GLOBAL.email = resp.data.email;
                                _this.$router.push('/Index');
                            }
                            else {
                                _this.$alert('You have completed the written version of the test, please exit！', 'Notice', {
                                    confirmButtonText: 'OK',
                                });
                            }
                        }
                        //未达到规定时间，当前不能做第二次aural
                        else {
                            // _this.$alert('It will take one month to test the written version. The last time you completed the aural version：'+String(resp.data.aural_donetime), 'Notice', {
                            //     confirmButtonText: 'OK',
                            _this.$alert('It will take one month to test the aural version. The last time you completed the written version：' + String(resp.data.word_donetime), 'Notice', {
                                confirmButtonText: 'OK',
                            });
                        }
                    }
                    //未完成文字版
                    else {
                        _this.$alert('You have not completed your first written version test yet, please go and complete it first', 'Notice', {
                            confirmButtonText: 'OK',
                        });
                    }

                }
                // 如果邮箱已经被使用
                else {
                    _this.$alert('Email not registered on this system! Please re-enter', 'Notice', {
                        confirmButtonText: 'OK',
                    });
                }
            });
        },

    },
    mounted() {
        history.pushState(null, null, document.URL);
        window.addEventListener('popstate', function () {
            history.pushState(null, null, document.URL);
        });

    }
}
</script>

<style scoped>
.header {
    height: 100px;
    line-height: 100px;
    background-color: #D8D8D8;
    text-align: center;
    margin-bottom: 80px
}

.footer {
    height: 100px;
    line-height: 100px;
    text-align: center;
    margin-bottom: 80px
}

.el-row {
    display: flex;
    margin-bottom: 80px;
    justify-content: center
}

.yesbutton {
    display: flex;
    justify-content: center;
    margin-bottom: 80px
}

.row {
    display: flex;
    justify-content: center;
    margin-bottom: 80px
}

.container {
    display: flex;
    flex-direction: column;
    height: 100vh;
}

.content {
    display: flex;
    flex-direction: row;
    flex: 1;
}

.el-row {
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-bottom: 80px
}

.left,
.right {
    width: 400px;
}

.center {
    flex: 1;
}
</style>